import axios from "~/plugins/axios";

export default {
  find(officeId, includes = []) {
    return axios.get(`/web_api/v1/office/${officeId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },

  delete(officeId) {
    return axios.delete(`/web_api/v1/office/delete/${officeId}`)
      .then((response) => response.data);
  },

  getByIds(officeIds, includes = []) {
    return axios.post("/web_api/v1/office/by_ids", { office_ids: officeIds }, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },

  getWithoutRegions(includes = []) {
    return axios.get("/web_api/v1/office/without_regions", {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },

  paginateOffices(page = 1, perPage = 15) {
    return axios.get("/web_api/v1/office/index/paginate", { params: { page, perPage } })
      .then((response) => response.data);
  },

  searchByName(name) {
    return axios.post("/web_api/v1/office/search/by_name", { query: name })
      .then((response) => response.data);
  },
  findByCustomer(customerId) {
    return axios.get(`/web_api/v1/office/by_customer/${customerId}`)
      .then((response) => response.data);
  },
};
